export const PR_PADRAO = 0.75;
export const NOME_INDICE_PR = 'Performance Ratio (PR)';

const numeroPR = (valor) => {
  if (valor === null || valor === undefined || valor === '') return null;
  const numero = typeof valor === 'number' ? valor : Number(String(valor).replace(',', '.'));
  return Number.isFinite(numero) && numero > 0 ? numero : null;
};

export function prSalvo(proposta, modalidade = 'ongrid') {
  if (modalidade === 'offgrid') {
    // O off-grid antigo ignorava proposta.pr; só o novo snapshot específico
    // comprova que outro PR foi aplicado a este dimensionamento.
    return numeroPR(proposta?.dimensionamentoOffGrid?.pr) ?? numeroPR(proposta?.dadosOffGrid?.pr);
  }
  if (modalidade === 'bombeamento') return numeroPR(proposta?.dimensionamentoBomb?.rendFV);
  return numeroPR(proposta?.pr);
}

export function temDimensionamentoHistorico(proposta, modalidade = 'ongrid') {
  if (!proposta?._id) return false;
  if (modalidade === 'offgrid') {
    return Boolean(proposta.dimensionamentoOffGrid?.potenciaCC || proposta.dadosOffGrid?.potenciaCC);
  }
  if (modalidade === 'bombeamento') return Boolean(proposta.dimensionamentoBomb?.potCC);
  return Boolean(proposta.kit?._id || proposta.kit?.potenciacc || proposta.hsp);
}

// Documentos nunca consultam o índice vigente: usam o snapshot, ou o legado.
export const prDaProposta = (proposta, modalidade = 'ongrid') => prSalvo(proposta, modalidade) ?? PR_PADRAO;

export function resolverPR({ proposta, indices, modalidade = 'ongrid' } = {}) {
  if (modalidade !== 'kit') {
    const salvo = prSalvo(proposta, modalidade);
    if (salvo !== null) return { pr: salvo, origem: 'salvo', aviso: '' };
    if (temDimensionamentoHistorico(proposta, modalidade)) {
      return { pr: PR_PADRAO, origem: 'legado', aviso: 'PR histórico não registrado. Mantido o padrão legado de 75%.' };
    }
  }
  if (indices === null || indices === undefined) return { pr: null, origem: 'carregando', aviso: '' };
  if (!Array.isArray(indices)) throw new Error('Não foi possível consultar o índice de PR. Tente novamente.');
  const encontrados = indices.filter((indice) => indice.nome === NOME_INDICE_PR);
  if (encontrados.length > 1) throw new Error('Há mais de um índice de PR cadastrado. Revise o cadastro de índices.');
  if (!encontrados.length) {
    return { pr: PR_PADRAO, origem: 'padrao', aviso: 'Índice de PR não cadastrado. Utilizado o padrão de 75%.' };
  }
  const pr = numeroPR(encontrados[0].valor);
  if (pr === null || pr > 1) throw new Error('PR inválido. No cadastro de índices, informe um fator maior que zero e até 1, como 0,75.');
  return { pr, origem: 'indice', aviso: '' };
}
